// 汗汗漫画 Mock 数据
export interface MangaChapter {
  id: string;
  title: string;
  number: number;
  updateDate: string;
}

export interface Manga {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  categories: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  updateDate: string;
  chapters: MangaChapter[];
  tags: string[];
}

export const categories = [
  { slug: 'all', name: '全部' },
  { slug: 'romance', name: '恋爱' },
  { slug: 'fantasy', name: '奇幻' },
  { slug: 'action', name: '热血' },
  { slug: 'drama', name: '剧情' },
  { slug: 'comedy', name: '搞笑' },
  { slug: 'thriller', name: '悬疑' },
  { slug: 'daily', name: '日常' },
  { slug: 'bl', name: 'BL' },
];

export const mangas: Manga[] = [
  {
    id: 'manga-1',
    title: '女神降临',
    author: '猫咪',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romance%20manhwa%20cover%20art%20featuring%20a%20beautiful%20young%20woman%20with%20makeup%20transformation%20theme%2C%20soft%20pastel%20pink%20background%2C%20clean%20anime%20illustration%20style%2C%20elegant%20and%20feminine%20aesthetic%2C%20high%20quality%20digital%20art%2C%20manhwa%20cover%20design%20with%20centered%20female%20character%2C%20delicate%20linework%2C%20subtle%20glow%20effects&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    description: '外貌普通的任朱静通过化妆技巧华丽变身为校园女神，但真实面貌的秘密让她在校园生活中充满挑战与惊喜。这是一部关于自信、成长与真爱的青春校园漫画。',
    categories: ['romance', 'drama', 'daily'],
    status: '连载中',
    rating: 9.5,
    views: 1250000,
    updateDate: '2026-08-03',
    chapters: Array.from({ length: 186 }, (_, i) => ({
      id: `ch-1-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.floor(i / 4) + 1).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    tags: ['校园', '恋爱', '化妆', '变身', '青春'],
  },
  {
    id: 'manga-2',
    title: '我独自升级',
    author: 'Chugong',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20fantasy%20manhwa%20cover%20art%20with%20a%20powerful%20male%20warrior%20in%20dark%20armor%2C%20glowing%20blue%20energy%20effects%2C%20dramatic%20dark%20background%20with%20monsters%2C%20epic%20illustration%20style%2C%20intense%20action%20vibe%2C%20cool%20color%20tones%2C%20high%20contrast%2C%20gaming%20level-up%20theme&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    description: '在突然出现连接异次元的"门"的世界中，最弱猎人成振宇在一次双重地下城事件后获得了神秘系统的力量，开始了从E级最弱到S级最强的逆袭之路。',
    categories: ['action', 'fantasy'],
    status: '已完结',
    rating: 9.8,
    views: 3500000,
    updateDate: '2025-12-20',
    chapters: Array.from({ length: 179 }, (_, i) => ({
      id: `ch-2-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2025-${String(Math.floor(i / 6) + 1).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    tags: ['战斗', '系统', '升级', '逆袭', '猎人'],
  },
  {
    id: 'manga-3',
    title: '甜蜜家园',
    author: '金坎比',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20horror%20thriller%20manhwa%20cover%20art%20apartment%20building%20with%20monsters%2C%20dark%20atmospheric%20scene%2C%20survival%20horror%20theme%2C%20gritty%20illustration%20style%2C%20dim%20lighting%2C%20tense%20mood%2C%20poster%20design%20featuring%20silhouettes%20against%20ominous%20red%20sky&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    description: '在怪物横行的末日世界中，公寓楼的幸存者们为了求生而共同努力。车贤秀与邻居们在绝望中互相扶持，共同抵抗内心与外界怪物的双重威胁。',
    categories: ['thriller', 'drama', 'action'],
    status: '已完结',
    rating: 9.3,
    views: 2100000,
    updateDate: '2025-10-15',
    chapters: Array.from({ length: 141 }, (_, i) => ({
      id: `ch-3-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2025-${String(Math.floor(i / 5) + 1).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    tags: ['恐怖', '生存', '怪物', '末日', '人性'],
  },
  {
    id: 'manga-4',
    title: '看脸时代',
    author: '朴泰俊',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20school%20drama%20manhwa%20cover%20art%20showing%20two%20contrasting%20male%20characters%20one%20handsome%20and%20one%20overweight%2C%20split%20composition%2C%20modern%20illustration%20style%2C%20social%20commentary%20theme%2C%20clean%20digital%20coloring%2C%20dramatic%20lighting%20contrast&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    description: '因为外貌丑陋而饱受欺凌的朴亨锡，某天醒来发现自己可以在两个身体之间切换——一个是原来的胖身体，一个是完美的帅哥身体。这部漫画深刻探讨了外貌歧视这一社会问题。',
    categories: ['drama', 'action', 'daily'],
    status: '连载中',
    rating: 9.4,
    views: 2800000,
    updateDate: '2026-08-01',
    chapters: Array.from({ length: 420 }, (_, i) => ({
      id: `ch-4-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.floor(i / 8) + 1).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    tags: ['校园', '社会', '双面人生', '格斗', '成长'],
  },
  {
    id: 'manga-5',
    title: '她的私生活',
    author: '金成妍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20comedy%20manhwa%20cover%20art%20featuring%20a%20professional%20woman%20with%20secret%20fangirl%20life%2C%20bright%20and%20cheerful%20illustration%20with%20idol%20posters%20in%20background%2C%20warm%20color%20palette%2C%20modern%20Seoul%20setting%2C%20lighthearted%20romantic%20comedy%20vibe&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    description: '美术馆策展人成德美私下是一名狂热的偶像粉丝。当新任馆长莱恩·戈尔德发现了她的秘密，两人之间展开了一段温馨有趣的办公室恋情。',
    categories: ['romance', 'comedy'],
    status: '已完结',
    rating: 9.1,
    views: 1800000,
    updateDate: '2025-08-30',
    chapters: Array.from({ length: 123 }, (_, i) => ({
      id: `ch-5-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2025-${String(Math.floor(i / 5) + 1).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    tags: ['职场', '粉丝文化', '甜蜜', '办公室', '恋爱'],
  },
  {
    id: 'manga-6',
    title: '流氓读书会',
    author: '玄敏',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20school%20manhwa%20cover%20art%20featuring%20a%20student%20studying%20intensely%20while%20a%20fight%20scene%20brews%20behind%2C%20dynamic%20composition%2C%20bold%20colors%2C%20school%20uniform%20aesthetic%2C%20determined%20expression%2C%20high%20energy%20illustration&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    description: '为了考上大学，尹佳敏创建了读书会。但在暴力横行的校园里，学习变成了一场斗争。他以拳头保护朋友们的同时，也坚守着对学业的执着追求。',
    categories: ['action', 'comedy', 'drama'],
    status: '连载中',
    rating: 9.2,
    views: 1500000,
    updateDate: '2026-08-02',
    chapters: Array.from({ length: 210 }, (_, i) => ({
      id: `ch-6-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.floor(i / 7) + 1).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    tags: ['校园', '格斗', '学习', '友情', '热血'],
  },
  {
    id: 'manga-7',
    title: '全知读者视角',
    author: 'sing N song',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20apocalypse%20manhwa%20cover%20art%20with%20a%20man%20reading%20a%20glowing%20book%20in%20a%20destroyed%20cityscape%2C%20epic%20fantasy%20illustration%2C%20constellation%20motifs%20in%20sky%2C%20dramatic%20lighting%2C%20sci-fi%20and%20fantasy%20blend%2C%20heroic%20pose&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    description: '金独子是一个普通上班族，也是唯一一部超长网络小说《在灭亡世界生存的三种方法》的唯一读者。当小说中的末日场景在现实中上演，他成了唯一知道结局的人。',
    categories: ['fantasy', 'action', 'drama'],
    status: '连载中',
    rating: 9.7,
    views: 2900000,
    updateDate: '2026-07-30',
    chapters: Array.from({ length: 195 }, (_, i) => ({
      id: `ch-7-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.floor(i / 6) + 1).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    tags: ['末日', '小说', '系统', '星座', '生存'],
  },
  {
    id: 'manga-8',
    title: '勇敢的市民',
    author: '金俊贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20comedy%20action%20manhwa%20cover%20art%20featuring%20a%20masked%20female%20vigilante%20in%20urban%20night%20setting%2C%20dynamic%20illustration%20style%2C%20humorous%20tone%20with%20action%20elements%2C%20neon%20city%20lights%20background%2C%20strong%20female%20lead%20character%20in%20heroic%20pose&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    description: '萧市民是一位看似普通的兼职教师，但她的真实身份是一名正义的格斗高手。每当遇到不公义的事情，她就会戴上面具，用自己的拳头教训那些嚣张的恶势力。',
    categories: ['action', 'comedy'],
    status: '连载中',
    rating: 8.9,
    views: 980000,
    updateDate: '2026-07-28',
    chapters: Array.from({ length: 98 }, (_, i) => ({
      id: `ch-8-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.floor(i / 4) + 1).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    tags: ['女性主角', '格斗', '正义', '搞笑', '都市'],
  },
  {
    id: 'manga-9',
    title: '我的ID是江南美人',
    author: '淇萌',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20drama%20manhwa%20cover%20art%20with%20a%20beautiful%20college%20student%20on%20campus%2C%20warm%20spring%20cherry%20blossom%20atmosphere%2C%20soft%20and%20elegant%20illustration%20style%2C%20plastic%20surgery%20social%20theme%2C%20delicate%20facial%20features%2C%20romantic%20college%20setting&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    description: '因为外貌从小被嘲笑的美来，在整容后以全新的面貌进入大学。然而美丽的外表并没有解决她内心的问题，反而让她开始重新思考什么是真正的美。',
    categories: ['romance', 'drama', 'daily'],
    status: '已完结',
    rating: 9.3,
    views: 2200000,
    updateDate: '2025-06-10',
    chapters: Array.from({ length: 100 }, (_, i) => ({
      id: `ch-9-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2025-${String(Math.floor(i / 4) + 1).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    tags: ['校园', '整容', '自我认同', '恋爱', '成长'],
  },
  {
    id: 'manga-10',
    title: '鬼传',
    author: '李秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20ghost%20hunting%20manhwa%20cover%20art%20with%20traditional%20Korean%20shaman%20elements%2C%20supernatural%20theme%20with%20spirits%2C%20dark%20mystical%20atmosphere%2C%20traditional%20and%20modern%20blend%2C%20intricate%20illustration%20with%20ethereal%20glowing%20effects%2C%20horror%20fantasy%20genre&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    description: '拥有看见鬼魂能力的少年金哲秀，意外卷入了一场跨越数百年的恩怨。在阴阳两界之间，他必须运用自己的能力解开咒怨，拯救无辜的生命。',
    categories: ['fantasy', 'thriller', 'action'],
    status: '连载中',
    rating: 9.0,
    views: 1600000,
    updateDate: '2026-08-03',
    chapters: Array.from({ length: 156 }, (_, i) => ({
      id: `ch-10-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.floor(i / 5) + 1).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    tags: ['灵异', '鬼怪', '传统', '超自然', '冒险'],
  },
  {
    id: 'manga-11',
    title: '保姆日记',
    author: '姜草',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20slice%20of%20life%20family%20manhwa%20cover%20art%20featuring%20a%20warm%20home%20setting%20with%20children%20and%20caregiver%2C%20heartwarming%20illustration%20style%2C%20soft%20cozy%20lighting%2C%20domestic%20bliss%20aesthetic%2C%20gentle%20color%20palette%2C%20family-oriented%20theme&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    description: '三兄妹在母亲出差期间由保姆照看的日子，看似平凡的日常中却充满了温暖与感动。姜草用细腻的笔触描绘了家庭的意义和成长的点滴。',
    categories: ['daily', 'drama', 'comedy'],
    status: '已完结',
    rating: 9.1,
    views: 850000,
    updateDate: '2025-04-18',
    chapters: Array.from({ length: 85 }, (_, i) => ({
      id: `ch-11-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2025-${String(Math.floor(i / 3) + 1).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    tags: ['家庭', '温情', '日常', '成长', '治愈'],
  },
  {
    id: 'manga-12',
    title: '神之塔',
    author: 'SIU',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20adventure%20manhwa%20cover%20art%20with%20a%20mysterious%20tower%20reaching%20into%20the%20sky%2C%20epic%20scale%2C%20diverse%20characters%20climbing%2C%20grand%20fantasy%20illustration%2C%20mystical%20atmosphere%2C%20intricate%20world-building%20visual%2C%20hero%20with%20determined%20expression&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    description: '只要登上塔顶就能实现任何愿望。少年夜为了追寻唯一的朋友蕾哈尔而进入神之塔，在每一层的试炼中结识伙伴，逐渐揭开塔的秘密。',
    categories: ['fantasy', 'action', 'drama'],
    status: '连载中',
    rating: 9.6,
    views: 3200000,
    updateDate: '2026-07-25',
    chapters: Array.from({ length: 550 }, (_, i) => ({
      id: `ch-12-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.floor(i / 10) + 1).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    tags: ['冒险', '试炼', '塔', '友情', '史诗'],
  },
];

export const featuredMangaIds = ['manga-7', 'manga-2', 'manga-1', 'manga-3', 'manga-12'];

export const heroMangas = mangas.filter(m => ['manga-2', 'manga-7', 'manga-1'].includes(m.id));